module.exports = __webpack_public_path__ + "img/rockyinternet.2fad93b1.png";